// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.object("BattlePassChallenge", {
  id: __t.u64(),
  seasonId: __t.u32(),
  challengeType: __t.string(),
  title: __t.string(),
  description: __t.string(),
  requirementType: __t.string(),
  requirementValue: __t.u32(),
  xpReward: __t.u64(),
  rotationSlot: __t.u32(),
  activeFrom: __t.u64(),
  activeUntil: __t.u64(),
});


